import _ from 'lodash';
import api from '../api';
import { v4 as uuidv4 } from 'uuid';

import * as MediaApi from './MediaApi';
import MediaConstants from './MediaConstants';

const receivedMedia = (media) => ({
    type: MediaConstants.MEDIA_RECEIVED,
    payload: media
});

export function fetchMediaItem(mediaId) {
    return function (dispatch) {
        return MediaApi.getMedia(mediaId).then(media => {
            dispatch(receivedMedia(media))
        });
    };
}

export function fetchMediaList(accountId) {
    return function (dispatch) {
        return MediaApi.listMedia(accountId).then(response => {
            _.map(response, media => {
                dispatch(receivedMedia(media))
            });
        });
    };
}

const removedMedia = (mediaId) => ({
    type: MediaConstants.MEDIA_REMOVED,
    payload: {
        id: mediaId,
    }
});

export function removeMedia(mediaId) {
    return function (dispatch, getState) {
        dispatch(removedMedia(mediaId));

        return MediaApi.removeMedia(mediaId);
    }
}

export function downloadMedia(mediaId) {
    return function (dispatch, getState) {
        return MediaApi.downloadMedia(mediaId).then(response => {
            window.location = response.url;
        });
    }
}













const uploadStarted = (id, file) => ({
    type: MediaConstants.UPLOAD_STARTED,
    payload: {
        id: id,
        filename: file.name
    }
});

const uploadProgress = (id, percentage) => ({
    type: MediaConstants.UPLOAD_PROGRESS,
    payload: {
        id: id,
        progress: percentage
    }
});

const uploadComplete = id => ({
    type: MediaConstants.UPLOAD_COMPLETE,
    payload: {
        id: id
    }
});

const uploadError = id => ({
    type: MediaConstants.UPLOAD_ERROR,
    payload: {
        id: id
    }
});


export function uploadFile(file) {
    return function (dispatch, getState) {
        const id = uuidv4();

        dispatch(uploadStarted(id, file));

        const accountId = getState().currentAccountId;

        const formData = new FormData;
        formData.append("upload", file);
        formData.append("account_id", accountId);
        formData.append("id", id);
        formData.append("label", file.name);
        formData.append("filename", file.name);

        const onUploadProgress = (progressEvent) => {
            if ( ! progressEvent.lengthComputable) {
                return;
            }

            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

            dispatch(uploadProgress(id, percentCompleted))
        };

        return api.post('/media', formData, {
            headers: {'Content-Type': 'multipart/form-data' },
            onUploadProgress: onUploadProgress
        }).then(response => {
            //handle success
            dispatch(uploadComplete(id));
            dispatch(fetchMediaItem(id)); // @todo ... single media file...
        })
        .catch(response => {
            //handle error
            dispatch(uploadError(id));
        });
    }
}
